import { render } from "./QuickResponses.vue?vue&type=template&id=e052ff46&scoped=true&lang=pug"
import script from "./QuickResponses.vue?vue&type=script&lang=js"
export * from "./QuickResponses.vue?vue&type=script&lang=js"

import "./QuickResponses.vue?vue&type=style&index=0&id=e052ff46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e052ff46"]])

export default __exports__